import { useRef, useState } from "react";
import { Disclosure } from "@/components/Provenance";

export const BeforeAfter = ({ before, after, width, height, testid = "before-after-slider", rounded = true, beforeLabel = "Before", afterLabel = "After" }) => {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const update = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <div
      ref={ref}
      data-testid={testid}
      data-position={Math.round(pos)}
      className={`relative w-full select-none overflow-hidden bg-[var(--sand)] ${rounded ? "rounded-xl" : ""}`}
      style={{ aspectRatio: `${width} / ${height}`, touchAction: "pan-y", cursor: "ew-resize" }}
      onPointerDown={(e) => {
        dragging.current = true;
        e.currentTarget.setPointerCapture?.(e.pointerId);
        update(e.clientX);
      }}
      onPointerMove={(e) => dragging.current && update(e.clientX)}
      onPointerUp={() => (dragging.current = false)}
      onPointerCancel={() => (dragging.current = false)}
    >
      <img src={after} alt="Reimagined" draggable={false} data-testid={`${testid}-after-image`} className="absolute inset-0 h-full w-full object-contain" />
      <img
        src={before}
        alt="Original"
        draggable={false}
        data-testid={`${testid}-before-image`}
        className="absolute inset-0 h-full w-full object-contain"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      />
      <Disclosure testid={`${testid}-disclosure`} />
      <span className="pointer-events-none absolute left-3 top-3 rounded-full bg-[var(--charcoal)]/70 px-2.5 py-1 font-mono-ui text-[0.6rem] uppercase tracking-[0.08em] text-[var(--bone)]">{beforeLabel}</span>
      <span className="pointer-events-none absolute right-3 top-3 rounded-full bg-[var(--bone)]/85 px-2.5 py-1 font-mono-ui text-[0.6rem] uppercase tracking-[0.08em] text-[var(--charcoal)]">{afterLabel}</span>
      <div className="pointer-events-none absolute inset-y-0" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -ml-px w-0.5 bg-[var(--bone)] shadow-[0_0_0_1px_rgba(31,28,25,.15)]" />
        <div className="absolute top-1/2 -ml-6 -mt-6 flex h-12 w-12 items-center justify-center rounded-full border border-[var(--charcoal)]/20 bg-[var(--bone)] shadow-lg">
          <svg width="20" height="12" viewBox="0 0 20 12" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M6 1 1 6l5 5M14 1l5 5-5 5" /></svg>
        </div>
      </div>
      <input
        type="range"
        min="0"
        max="100"
        value={Math.round(pos)}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Before and after comparison"
        data-testid={`${testid}-range`}
        className="sr-only"
      />
    </div>
  );
};
